import { useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { CheckCircle2, Circle, Loader2 } from 'lucide-react'
import { chatService } from '../../services/chatService'
import { toast } from '../../stores/uiStore'

/**
 * Mesaj balonundaki anket kartı.
 * Aynı seçeneğe ikinci tıklama oyu GERİ ALIR (WhatsApp davranışı).
 * Gizli ankette oy verenlerin adı hiç gelmez — sunucu göndermiyor.
 */
export default function PollCard({ pollId, company }) {
  const qc = useQueryClient()
  const [busy, setBusy] = useState(false)
  const { data, isLoading } = useQuery({
    queryKey: ['chat-poll', pollId],
    queryFn: () => chatService.getPoll(company, pollId),
    enabled: !!pollId,
    staleTime: 15_000,
  })
  const p = data?.data
  if (isLoading || !p) {
    return <div className="w-[280px] h-14 flex items-center justify-center text-gray-300"><Loader2 size={16} className="animate-spin" /></div>
  }

  const vote = async (i) => {
    if (p.closed || busy) return
    const mine = p.my_votes || []
    let next
    if (p.multi) next = mine.includes(i) ? mine.filter((x) => x !== i) : [...mine, i]
    else next = mine.includes(i) ? [] : [i]
    setBusy(true)
    try {
      await chatService.votePoll(company, pollId, next)
      qc.invalidateQueries({ queryKey: ['chat-poll', pollId] })
    } catch (e) {
      toast.error('Oy kaydedilemedi', e.response?.data?.detail || e.message)
    } finally { setBusy(false) }
  }

  return (
    <div className="w-[300px] max-w-full mt-1.5 rounded-xl border border-gray-200 bg-gray-50 p-2.5">
      <div className="text-[13px] font-semibold text-gray-800 mb-2">{p.question}</div>
      {(p.options || []).map((o, i) => {
        const cnt = (p.counts || [])[i] || 0
        const pct = p.total ? Math.round((cnt / p.total) * 100) : 0
        const mine = (p.my_votes || []).includes(i)
        return (
          <button key={i} type="button" onClick={() => vote(i)} disabled={p.closed || busy}
            className="relative w-full mb-1.5 h-8 rounded-lg overflow-hidden text-left disabled:cursor-default">
            <div className={`absolute inset-y-0 left-0 ${mine ? 'bg-primary-100' : 'bg-gray-200'}`}
              style={{ width: `${pct}%` }} />
            <div className="relative flex items-center gap-2 px-2.5 h-full">
              {mine ? <CheckCircle2 size={14} className="text-primary-600 shrink-0" />
                : <Circle size={14} className="text-gray-400 shrink-0" />}
              <span className="flex-1 truncate text-[12.5px] text-gray-800">{o}</span>
              <span className="text-[12px] font-semibold text-gray-500 tabular-nums">{cnt}</span>
            </div>
          </button>
        )
      })}
      <div className="text-[11px] text-gray-400">
        {[`${p.total} oy`, p.anonymous ? 'gizli' : null, p.closed ? 'kapandı' : null]
          .filter(Boolean).join(' · ')}
      </div>
    </div>
  )
}
